import { AffiliateSettingsContent } from './affiliate-settings-content';

export { AffiliateSettingsContent };
